// File: App.jsx
import React from 'react';
import Home from './Pages/Home';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from './Context/ThemeContext';
import AboutUsPage from './Pages/AboutUs_page';
import ServicesPage from './Pages/Services_page';
import PricingPage from './Pages/Pricing_page';
import ContactPage from './Pages/Contact_page';
import PolicyPage from './Pages/Policy_page';
import ComplaintsPage from './Pages/Complaints_page';
import PaymentPage from './Pages/Payment_page';
import DisclosurePage from './Pages/Disclosure_page';
import InvestorCharterPage from './Pages/InvestorCharter_page';
import AllBlog from './Pages/Blog_Posts/All_blog';
import SingleBlog from './Pages/Blog_Posts/Single_blog';
import NewsPage from './Pages/News/News_page';
import ScrollToTop from './Components/ScrollToTop';
import RefundPolicyPage from './Pages/RefundPolicy_page';
import DisclaimerPage from './Pages/Disclaimer_page';
import TermsPage from './Pages/Terms_page';

import EsignDigio from './Pages/Esign/EsignDigio';
import CongratsPage from './Pages/success/Congrats_page';
function App() {  
  return (
    <ThemeProvider> {/* Wrapping with ThemeProvider */}
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route exact path='/about' element={<AboutUsPage />} />
          <Route exact path='/' element={<Home />} />
          <Route exact path='/services' element={<ServicesPage />} />
          <Route exact path='/pricing' element={<PricingPage />} />
          <Route exact path='/contact' element={<ContactPage />} />
          <Route exact path='/policy' element={<PolicyPage />} />
          <Route exact path='/complaints' element={<ComplaintsPage />} />
          <Route exact path='/disclosure' element={<DisclosurePage />} />
          <Route exact path='/investor-charter' element={<InvestorCharterPage />} />
          <Route exact path='/payment' element={<PaymentPage />} />
          <Route exact path='/payments' element={<PaymentPage />} />
          <Route exact path='/blog' element={<AllBlog />} />
          <Route exact path='/blog/:id' element={<SingleBlog />} />
          <Route exact path='/news' element={<NewsPage />} />
          <Route exact path='/refund' element={<RefundPolicyPage />} />
          <Route exact path='/disclaimer' element={<DisclaimerPage />} />
          <Route exact path='/terms' element={<TermsPage />} />
          <Route path='*' element={<Home />} />
          <Route exact path='/esign' element={<EsignDigio />} />
          <Route exact path='/success' element={<CongratsPage />} />

        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
